import React from 'react';
import { Route } from 'react-router-dom';
import ContainerRoute from './ContainerRoute'

import Main from '../pages/SP/Main';

import Intro from '../pages/IF/Intro';
import Platform from '../pages/IF/Platform';
import Promotion from '../pages/IF/Promotion';

import VLabLecture from '../pages/VX/VLC/VLabLectureList';
import VLabLectureView from '../pages/VX/VLC/VLabLectureView';
import XRContents from '../pages/VX/XRC/XRContentsList';
import XRContentsView from '../pages/VX/XRC/XRContentsView';

import NoticeList from '../pages/IS/NTC/NoticeList';
import NoticeView from '../pages/IS/NTC/NoticeView';
import FaqList from '../pages/IS/FAQ';
import InfView from '../pages/IS/INF';

import UserList from '../pages/Users/UserList';
import UserDetail from '../pages/Users/UserDetail';
import UserListNext from '../pages/Users/UserListNext';
import SignUp from '../pages/MM/MBE/SignUp';
import OAuthCallback from '../components/OAuthCallback';
import PortOneIdentityCallback from '../components/PortOneIdentityCallback';

import Login from '../pages/MM/LGI/Login';
import RecoverEmailAccount from '../pages/MM/LGI/RecoverEmailAccount';
import RecoverEmailAccountLater from '../pages/MM/LGI/RecoverEmailAccountLater';
import RecoverPassword from '../pages/MM/LGI/RecoverPassword';
import RecoverPasswordLater from '../pages/MM/LGI/RecoverPasswordLater';
import ResetPassword from '../pages/MM/LGI/ResetPassword';
import ResetPasswordLater from '../pages/MM/LGI/ResetPasswordLater';
import Inactivity from '../pages/MM/LGI/Inactivity';
import InactivityPhone from '../pages/MM/LGI/InactivityPhone';
import InactivityEmail from '../pages/MM/LGI/InactivityEmail';
import InactivityLater from '../pages/MM/LGI/InactivityLater';

import AuthMng       from '../pages/Mng/MS/SSM/AuthMng';
import AuthMngDetail from '../pages/Mng/MS/SSM/AuthMngDetail';
import AuthMngWrite  from '../pages/Mng/MS/SSM/AuthMngWrite';

import UserGrp       from '../pages/Mng/MS/SSM/UserGrp';
import UserGrpDetail from '../pages/Mng/MS/SSM/UserGrpDetail';
import UserGrpWrite  from '../pages/Mng/MS/SSM/UserGrpWrite';

import Terms from '../pages/Policy/Terms';
import Privacy from '../pages/Policy/Privacy';
import Copyright from '../pages/Policy/Copyright';

import ProtectedRoute from './ProtectedRoute';

import SearchPage from '../pages/Search/SearchPage';

// import NotFound from '../pages/n';

const UsersRoutes = () => (
  <>
    {/* 메인 */}
    {ContainerRoute('/', <Main />, { hideHeader: true, hasSidebar: false })}
    {ContainerRoute('/search', <SearchPage />)}

    {/* 사업소개 */}
    {ContainerRoute('/about/intro', <Intro />)}
    {ContainerRoute('/about/platform', <Platform />)}
    {ContainerRoute('/about/promotion', <Promotion />)}

    {/* 강좌-콘텐츠 */}
    {ContainerRoute('/contents/lecture', <VLabLecture />)}
    {ContainerRoute('/contents/lectureview/:id', <VLabLectureView />)}
    {ContainerRoute('/contents/xr', <XRContents />)}
    {ContainerRoute('/contents/xrview/:id', <XRContentsView />)}

    {/* 알림공간 */}
    {ContainerRoute('/alarm/notice', <NoticeList />)}
    {ContainerRoute('/alarm/noticeview', <NoticeView />)}
    {ContainerRoute('/alarm/faq', <FaqList />)}

    {/* User 관리 */}
    {ContainerRoute('/users', <UserList />)}
    {ContainerRoute('/users/userDetail', <UserDetail />)}
    {ContainerRoute('/users/userListNext', <UserListNext />)}

    {/* 회원가입/로그인 */}
    {ContainerRoute('/signup', <SignUp />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/oauth/callback', <OAuthCallback />)}
    {ContainerRoute('/portone/identity-callback', <PortOneIdentityCallback />)}

    {ContainerRoute('/login', <Login />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/recoveremailaccount', <RecoverEmailAccount />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/recoveremailaccountlater', <RecoverEmailAccountLater />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/recoverpassword', <RecoverPassword />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/recoverpasswordlater', <RecoverPasswordLater />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/resetpassword', <ResetPassword />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/resetpasswordlater', <ResetPasswordLater />, { hideHeader: false, contentMinWidth: true })}

    {ContainerRoute('/inactivity', <Inactivity />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/inactivity/phone', <InactivityPhone />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/inactivity/email', <InactivityEmail />, { hideHeader: false, contentMinWidth: true })}
    {ContainerRoute('/inactivity/later', <InactivityLater />, { hideHeader: false, contentMinWidth: true })}

    {/* 권한관리 */}
    {ContainerRoute('/mng/authMng', <AuthMng />)}
    {ContainerRoute('/mng/authMngDetail', <AuthMngDetail />)}
    {ContainerRoute('/mng/authMngWrite', <AuthMngWrite />)}

    {/* 사용자 그룹 */}
    {ContainerRoute('/mng/userGrp', <UserGrp />)}
    {ContainerRoute('/mng/userGrpDetail', <UserGrpDetail />)}
    {ContainerRoute('/mng/userGrpWrite', <UserGrpWrite />)}

    {/* 정책 */}
    {ContainerRoute('/policy/terms', <Terms />, { hasSidebar: false, contentMaxWidth: true })}
    {ContainerRoute('/policy/privacy', <Privacy />, { hasSidebar: false, contentMaxWidth: true })}
    {ContainerRoute('/policy/copyright', <Copyright />, { hasSidebar: false, contentMaxWidth: true })}
    
    {/* 알림공간-이용문의 및 제안 */}
    {ContainerRoute('/alarm/inquiry', <InfView />)}

    {/* ========== 로그인 필요한(보호) 라우트 : 여기에 추가 ========== */}
    <Route element={<ProtectedRoute />}>
      
    </Route>

  </>
);

export default UsersRoutes;